/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

document.addEventListener("click", function(e) {
  const chatLink = e.target.closest('a[href="#gorgias-chat"]');
  if (!chatLink) return;

  e.preventDefault();

  if (window.GorgiasChat && typeof GorgiasChat.open === "function") {
    GorgiasChat.open();
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const table = document.querySelector("table.specChart");
  if (!table) return;

  // Preserve thead/tbody/tfoot sections rather than grabbing raw <tr>s
  const sections = Array.from(table.childNodes); // keep structure
  const tbody = table.querySelector("tbody");
  if (!tbody) return;

  const rows = Array.from(tbody.rows);
  if (!rows.length) return;

  const midpoint = Math.ceil(rows.length / 2);
  const mq = window.matchMedia("(min-width: 768px)");

  let isSplit = false;
  let wrapper = null;

  // Build the two tables once and reuse them
  function buildSplitTables() {
    const makeTable = (rowSlice) => {
      const t = document.createElement("table");
      t.className = table.className;

      // Clone thead into each split table for proper semantics
      const thead = table.querySelector("thead");
      if (thead) t.appendChild(thead.cloneNode(true));

      const tb = document.createElement("tbody");
      rowSlice.forEach(r => tb.appendChild(r)); // move, don't clone
      t.appendChild(tb);
      return t;
    };

    wrapper = document.createElement("div");
    wrapper.className = "specChart-split";
    wrapper.appendChild(makeTable(rows.slice(0, midpoint)));
    wrapper.appendChild(makeTable(rows.slice(midpoint)));
  }

  function splitTable() {
    if (isSplit) return;
    if (!wrapper) buildSplitTables();

    table.replaceWith(wrapper);
    isSplit = true;
  }

  function unsplitTable() {
    if (!isSplit) return;

    // Move rows back into the original tbody (no cloning)
    rows.forEach(r => tbody.appendChild(r));
    wrapper.replaceWith(table);
    isSplit = false;
  }

  function handleChange(e) {
    e.matches ? splitTable() : unsplitTable();
  }

  mq.addEventListener("change", handleChange);
  handleChange(mq);
});


  // First-available variant selection.
  // When a user changes one option, this intercepts the change event in the
  // capture phase (before VariantSelects.changeHandler reads selectedOptionValues)
  // and updates the other popout inputs to point at the first available variant
  // that includes the newly chosen option value. If no available variant exists
  // the first sold-out matching variant is used so the section still re-renders.
  //
  // The idMap fallback handles the case where the target option value's <li> is
  // absent from the DOM (filtered out because the combination didn't exist under
  // the previously selected option). Without it, updatePopout silently returns
  // and VariantSelects sends the stale option-value-id, landing on an unavailable
  // combination.
  (function () {
    function getVariants(variantSelectsEl) {
      try {
        const el = variantSelectsEl.querySelector('[data-product-variants]');
        return el ? JSON.parse(el.textContent) : null;
      } catch (e) {
        return null;
      }
    }

    function getOptionValueIds(variantSelectsEl) {
      try {
        const el = variantSelectsEl.querySelector('[data-option-value-ids]');
        return el ? JSON.parse(el.textContent) : null;
      } catch (e) {
        return null;
      }
    }

    function findTargetVariant(variants, changedPos, changedValue, currentValues) {
      const prop = `option${changedPos}`;
      const matching = variants.filter(v => v[prop] === changedValue);
      if (!matching.length) return null;

      const otherEntries = Object.entries(currentValues).filter(([p]) => parseInt(p) !== changedPos);
      const othersMatch = v => otherEntries.every(([p, val]) => v[`option${p}`] === val);

      // Priority: available + keeps other options → keeps other options (sold out) → available → first
      // Sold-out combos rank above "redirect to a different available combo" so customers
      // can reach the sold-out state and sign up for a back-in-stock notification.
      return (
        matching.find(v => v.available && othersMatch(v)) ||
        matching.find(othersMatch) ||
        matching.find(v => v.available) ||
        matching[0]
      );
    }

    function updatePopout(container, valueStr, idMap, optionPos) {
      const input = container.querySelector('[data-popout-input]');
      if (!input) return;

      const link = Array.from(container.querySelectorAll('[data-popout-option]'))
        .find(el => el.dataset.value === valueStr);

      if (link) {
        // Target <li> is in the DOM — do a full visual + data update
        const li = link.closest('li');
        const newId = li && li.getAttribute('data-option-value-id');
        if (!newId) return;

        input.value = valueStr;
        input.setAttribute('data-option-value-id', newId);

        const text = container.querySelector('[data-popout-text]');
        if (text) text.textContent = valueStr;

        container.querySelectorAll('.select-popout__item--current')
          .forEach(el => el.classList.remove('select-popout__item--current'));
        li.classList.add('select-popout__item--current');

        container.querySelectorAll('[aria-current]')
          .forEach(el => el.removeAttribute('aria-current'));
        link.setAttribute('aria-current', 'true');
      } else if (idMap && optionPos) {
        // Target <li> is absent because the combo wasn't rendered in the current
        // option context. Look up the stable option-value-id from the pre-built
        // map so VariantSelects still gets the right id for its AJAX request.
        const valueId = idMap[`option${optionPos}`] && idMap[`option${optionPos}`][valueStr];
        if (!valueId) return;

        input.value = valueStr;
        input.setAttribute('data-option-value-id', String(valueId));

        const text = container.querySelector('[data-popout-text]');
        if (text) text.textContent = valueStr;
      }
    }

    // Capture phase so this runs before VariantSelects.changeHandler (bubble phase)
    document.addEventListener('change', function (e) {
      const input = e.target;
      if (!input.matches || !input.matches('[data-popout-input]')) return;

      const vs = input.closest('variant-selects');
      if (!vs) return;

      const variants = getVariants(vs);
      if (!variants || !variants.length) return;

      const idMap = getOptionValueIds(vs);

      const indexAttr = input.dataset.index;
      if (!indexAttr) return;
      const changedPos = parseInt(indexAttr.replace('option', ''));
      const changedValue = input.value;
      if (!changedValue || !changedPos) return;

      const allInputs = Array.from(vs.querySelectorAll('[data-popout-input]'));
      const currentValues = {};
      allInputs.forEach(p => {
        const pos = parseInt((p.dataset.index || '').replace('option', '') || '0');
        if (pos) currentValues[pos] = p.value;
      });

      const target = findTargetVariant(variants, changedPos, changedValue, currentValues);
      if (!target) return;

      allInputs.forEach(p => {
        const pos = parseInt((p.dataset.index || '').replace('option', '') || '0');
        if (!pos || pos === changedPos) return;
        const targetValue = target[`option${pos}`];
        if (!targetValue || targetValue === p.value) return;
        const container = p.closest('popout-select');
        if (container) updatePopout(container, targetValue, idMap, pos);
      });
    }, true); // true = capture phase
  }());

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
